<template lang="pug">

q-header.bg-grey-2
  q-toolbar.q-pa-md
    q-icon.q-mr-md(name="chat" size="md" color="green")
    .text-h4.text-black <router-link class="text-primary" to="/home">CHeKT Ham</router-link> Chat

</template>

<style>
a { 
  text-decoration: none; 
}
</style>

<script>
export default {
}
</script>
